module.exports = __webpack_public_path__ + "static/media/new_mall.5de67fe0.png";